// extracted by mini-css-extract-plugin
export default {"AbooutBlock":"about_AbooutBlock__QEN8r","AboutProjects":"about_AboutProjects__BOl6R","features":"about_features__5mUHF"};